module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps Facts.f2dedd76.webp";